import React from 'react';
import styles from './TabContainer.module.scss';

const TabContainer = ({ children }) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
};

export default TabContainer;
